// extracted by mini-css-extract-plugin
module.exports = {"container":"starmap_container__2NAaZ"};